module.exports = __webpack_public_path__ + "b99f014197fa3fd582ae45c0b686783e.svg";